import { useEffect, useState } from "react";
import ButtonSocial from "../../components/ButtonSocial";
import axios from "axios";

function ExternalAuth() {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    function linkGenerate(type) {
        setLoading(type);
        setLog(null);

        axios.post('/api/user/authPkceGenerate')
            .then((res) => {
                if (res.data.Status === 1) {
                    if (type === 'vk') {
                        const url = 'https://id.vk.com/authorize?response_type=code&client_id=53054071&scope=email%20phone&redirect_uri=' + process.env.REACT_APP_DOMAIN_MAIN + '/auth/vk&code_challenge=' + res.data.Data.Code_Challenge + '&code_challenge_method=S256&state=' + res.data.Data.ID;
                        window.location.href = url;
                        //TEMP
                        /*const url_ = 'https://id.vk.com/authorize?response_type=code&client_id=53054071&scope=email%20phone&redirect_uri=' + process.env.REACT_APP_DOMAIN_MAIN + '&code_challenge=' + res.data.Data.Code_Challenge + '&code_challenge_method=S256&state=' + res.data.Data.ID;
                        console.log('url', url_)
                        setLog('VK в работе...');*/

                    }
                    if (type === 'ya') {
                        const url = 'https://oauth.yandex.ru/authorize?response_type=code&client_id=08bc3cd18c56450aa52de54a825dbabb&redirect_uri=' + process.env.REACT_APP_DOMAIN_MAIN + '/auth/ya&code_challenge=' + res.data.Data.Code_Challenge + '&code_challenge_method=S256&state=' + res.data.Data.ID;
                        window.location.href = url;
                    }
                }
                else {
                    setLog(res.data.Data.Error);
                    setLoading(null);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(null);
            });
    }

    return (
        <>
            <div className="mt-2">
                <ButtonSocial type='vk' loading={loading === 'vk' ? true : false} onClick={(e) => linkGenerate('vk')} />
            </div>
            <div className="mt-2">
                <ButtonSocial type='ya' loading={loading === 'ya' ? true : false} onClick={(e) => linkGenerate('ya')} />
            </div>
            {log !== null && <div className="log_form_light mt-2">{log}</div>}
        </>
    );
}

export default ExternalAuth;
